module.exports = __webpack_public_path__ + "img/COM-B-1-I.a49e026b.png";